<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
      <g stroke="currentColor" stroke-width="3">
        <path d="M5 15.022L11.994 8.005 5 1" />
      </g>
    </g>
  </svg>
</template>
